import type { TransactionItemDetail } from 'models';
import { Form, FormActions, Modal } from 'ui';
import { AdditionalInfoFormContent } from '../../../../../components';

export type TestimonialEditFormValues = {
  displayName: boolean;
  reason: string;
};

type P = {
  isLoading: boolean;
  onCancel: () => void;
  onSuccess: (values: TestimonialEditFormValues) => void;
  testimonial: TransactionItemDetail;
};

const TestimonialEditForm = ({ isLoading, onCancel, onSuccess, testimonial }: P) => {
  const onFinish = (values: TestimonialEditFormValues) => {
    onSuccess(values);
  };

  const initialValues: Partial<TestimonialEditFormValues> = {
    displayName: !testimonial.anonymous,
    reason: testimonial.textContent,
  };

  return (
    <Form<TestimonialEditFormValues> initialValues={initialValues} onFinish={onFinish}>
      <AdditionalInfoFormContent<TestimonialEditFormValues> />
      <Modal.HugContent.Footer>
        <FormActions
          right={{
            children: 'Cancel',
            onClick() {
              onCancel();
            },
          }}
          submit={{ children: 'Save', loading: isLoading }}
        />
      </Modal.HugContent.Footer>
    </Form>
  );
};

export default TestimonialEditForm;
